//core
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import arePropsEqual from "react-fast-compare";
import { Close, Edit } from "@mui/icons-material";

//routes
import routes from "../../../../../navigation/routes";

//hooks
import { usePermissions } from "../../../../../store/common/configuration/usePermissions";
import { useFlatFee } from "../../../../../store/admin/flatFee/useFlatFee";

//components
import ActionIconButton from "../../../../UI/Buttons/ActionIconButton";
import MuiModal from "../../../../UI/MuiModal";
import DeleteFlatFee from "../DeleteFlatFee";
import { itemListData } from "../../../../common/TableData";
import CreateUpdateFlatFee from "../CreateUpdateFlatFee";
import { PaymentIcon } from "../../../../UI/Icons";
import { usePayoutsModalContext } from "../Desktop/PayoutsModalContext";

export interface ITableActions {
  id: itemListData;
  data: any;
}

const TableActions = (props: ITableActions) => {
  let history = useNavigate();
  const { t } = useTranslation();
  const { hasPermissions } = usePermissions();

  const { updateFlatFee, deleteFlatFee } = useFlatFee();

  const { id, data } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showModalUpdate, setShowModalUpdate] = useState(false);

  const { openPayoutsModal } = usePayoutsModalContext();

  const hasDelete = hasPermissions(["api3.admin.flatfeecontroller.annulate"]);
  const hasUpdate = hasPermissions(["api3.admin.flatfeecontroller.edit"]);
	const isPermissionShowPayment = hasPermissions(["api3.admin.flatfeecontroller.payment_create"]);

  const handleClickDelete = useCallback(() => {
    deleteFlatFee(id);
    setShowDeleteModal(false);
	},[id]);

  const handleToggleDeleteModal = useCallback((state: boolean) => {
    setShowDeleteModal(state);
  }, [setShowDeleteModal]);

	const handleOpenUpdateFlatFee = useCallback((state: boolean) => {
		setShowModalUpdate(state);
	}, [setShowModalUpdate]);

  return (
    <>
	    {isPermissionShowPayment && (
		    <ActionIconButton
			    text={t("common.buttons.payment")}
			    icon={<PaymentIcon fontSize="small" color='primary'/>}
			    onClick={() => openPayoutsModal(data)}
		    />
	    )}

	    {
		    hasUpdate && <ActionIconButton
          text={t("common.buttons.edit")}
          icon={<Edit fontSize="small" color='primary'/>}
			    disabled={data.status.toLowerCase() === "annulated" || data.status.toLowerCase() === "closed"}
          onClick={() => handleOpenUpdateFlatFee(true)}
        />
	    }
      {
        hasDelete && <ActionIconButton
          text={t("common.buttons.annul")}
          icon={<Close fontSize="small" color='primary'/>}
          disabled={data.status.toLowerCase() === "annulated" || data.status.toLowerCase() === "closed"}
          onClick={() => handleToggleDeleteModal(true)}
        />
      }

	    {hasDelete && (<MuiModal
		    width={472}
		    open={showDeleteModal}
		    closeOnOutside={false}
		    setToggleModal={handleToggleDeleteModal}
	    >
		    <DeleteFlatFee
			    onAccept={handleClickDelete}
			    setToggleModal={handleToggleDeleteModal}
			    id={data.id}
		    />
	    </MuiModal>)}

	    {hasUpdate && (<MuiModal
		    width={496}
		    open={showModalUpdate}
		    closeOnOutside={false}
		    setToggleModal={setShowModalUpdate}
	    >
		    <CreateUpdateFlatFee
			    data={data}
			    closeModal={handleOpenUpdateFlatFee}
			    handleSubmitForm={updateFlatFee}
			    title={"admin.flatFee.createUpdateForm.update_title"}
          editMode={true}
		    />
	    </MuiModal>)}

    </>
  );
};

export default React.memo(TableActions, arePropsEqual);
